module.exports = __webpack_public_path__ + "static/img/23.574d7b3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/23.png
// module id = qKmS
// module chunks = 1